import { render, staticRenderFns } from "./EmployeeSkillsManager.vue?vue&type=template&id=679c25c2"
import script from "./EmployeeSkillsManager.vue?vue&type=script&lang=js"
export * from "./EmployeeSkillsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports